module.exports = __webpack_public_path__ + "img/brand-6.33ecef8b.png";